import { AutomationTemplateDefinitionPage } from "../../../Automations"

export default function NewAutomationPage() {
	return <AutomationTemplateDefinitionPage />
}
